import React from 'react';
import {
  Button,
  Grid,
  Icon,
  IconButton,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import DeleteIcon from '@material-ui/icons/Delete';
import { useStyles } from '../styles';
import { DateTime } from 'luxon';

const StatusTable = ({
  loading,
  assets,
  ticketId,
  refreshAssets,
  ticketNumber,
  handleEditRequest,
  handleReminderClick,
}: any) => {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow classes={{ root: classes.tableHead }}>
            <TableCell>
              <Typography
                classes={{ root: classes.tableHeadCell }}
                variant="subtitle2"
              >
                Title
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                classes={{ root: classes.tableHeadCell }}
                variant="subtitle2"
              >
                Description
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                classes={{ root: classes.tableHeadCell }}
                variant="subtitle2"
              >
                Tech Owner
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                classes={{ root: classes.tableHeadCell }}
                variant="subtitle2"
              >
                Asset Type
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                classes={{ root: classes.tableHeadCell }}
                variant="subtitle2"
              >
                Expected Date
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                classes={{ root: classes.tableHeadCell }}
                variant="subtitle2"
              >
                Status
              </Typography>
            </TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {assets?.data?.assets
            ?.filter((asset: any) => asset?.is_new_asset)
            .map((asset: any) => (
              <TableRow classes={{ root: classes.ticketTableRow }}>
                <TableCell>{asset?.asset_name}</TableCell>
                <TableCell>{asset?.asset_description}</TableCell>
                <TableCell>{asset?.tech_owner_email}</TableCell>
                <TableCell>{asset?.asset_type}</TableCell>
                <TableCell>
                  {asset?.expected_delivery_date
                    ? DateTime.fromISO(asset?.expected_delivery_date).toFormat(
                        'dd MMM yyyy, hh:mm a',
                      )
                    : '-'}
                </TableCell>
                <TableCell>{asset?.status}</TableCell>
                <TableCell className={classes.actionCell}>
                  <IconButton
                    className={`${classes.actionButton} ${classes.buttonvariant4}`}
                    onClick={() =>
                      handleEditRequest({ ticketId, ticketNumber, asset })
                    }
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    className={`${classes.actionButton} ${classes.buttonvariant4}`}
                    onClick={() =>
                      handleReminderClick({
                        tech_owner: asset.tech_owner,
                        id: asset.id,
                      })
                    }
                  >
                    <NotificationsActiveIcon />
                  </IconButton>
                  <IconButton
                    className={`${classes.actionButton} ${classes.buttonvariant4}`}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StatusTable;
